import type { ReactElement } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { IntegrationSyncTime } from "app/pages/sales-intelligence/pages/management/components/ManagementSections/components/IntegrationSyncTime/IntegrationSyncTime";
import { MANAGEMENT_BODY_TEXTS } from "app/pages/sales-intelligence/pages/management/translations/integrationsKeys";
import { selectHubspotStatusObject } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspotSelectors";
import { selectSalesforceStatusObject } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforceSelectors";
import type { ListsDropdownButtonProps } from "app/pages/sales-intelligence/sub-modules/opportunities/components/top-section/ListsDropdown/types";
import type { CrmListRoutingParams } from "app/pages/sales-intelligence/sub-modules/opportunities/types/routing";

import PageTitle from "../../components/PageTitleButton/PageTitle";
import PageTitleButton from "../../components/PageTitleButton/PageTitleButton";
import { StyledAutoCreatedTag } from "../../components/PageTitleButton/styles";

import { StyledIntegrationSyncTimeWrapper } from "./styles";

type Props = ListsDropdownButtonProps;

const CrmListPageTitleButtonContainer = ({ list, onClick }: Props): ReactElement => {
    const { params } = useCurrentStateAndParams<CrmListRoutingParams>();

    const hubspotStatus = useSelector(selectHubspotStatusObject);
    const salesforceStatus = useSelector(selectSalesforceStatusObject);

    return (
        <PageTitleButton onClick={onClick}>
            <PageTitle
                list={list}
                listTag={<StyledAutoCreatedTag />}
                listInfo={
                    <StyledIntegrationSyncTimeWrapper>
                        <IntegrationSyncTime
                            text={translate(MANAGEMENT_BODY_TEXTS[params.crm].syncText)}
                            time={params.crm === "hubspot" ? hubspotStatus.lastSynced : salesforceStatus.lastSynced}
                        />
                    </StyledIntegrationSyncTimeWrapper>
                }
            />
        </PageTitleButton>
    );
};

export default CrmListPageTitleButtonContainer;
